var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateBuilder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.218,
    height: 21.201,
    viewBox: "0 0 22.218 21.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_200",
    "data-name": "Union 200",
    d: "M1096.922-2422.8a2.915,2.915,0,0,1-2.908-2.908v-10.473c0-.08,0-.163-.007-.243a2.279,2.279,0,0,1,.052-.738,1.3,1.3,0,0,1,.054-.153,2.4,2.4,0,0,1,.643-.833l3.791-3.395q.863-.775,1.727-1.548c.086-.077.171-.155.256-.234.132-.122.27-.249.41-.369a1.421,1.421,0,0,1,.98-.307c.088,0,.178,0,.266.006s.175.006.261.006h5.34a2.915,2.915,0,0,1,2.908,2.907v3.881l1.3-1.3a2.064,2.064,0,0,1,1.467-.606,2.067,2.067,0,0,1,1.467.605l.687.687a2.08,2.08,0,0,1,0,2.934l-4.919,4.919v4.25a2.915,2.915,0,0,1-2.907,2.908Zm-1.258-2.908a1.261,1.261,0,0,0,1.258,1.258h10.864a1.262,1.262,0,0,0,1.258-1.259v-2.6l-1.4,1.4a.821.821,0,0,1-.381.216l-3.291.833a.824.824,0,0,1-.405,0,.825.825,0,0,1-.6-1l.836-3.288a.824.824,0,0,1,.216-.379l5.018-5.019v-5.53a1.263,1.263,0,0,0-1.258-1.258h-5.37v3.141a2.916,2.916,0,0,1-2.908,2.908h-3.845Zm9.689-3.818-.438,1.724,1.726-.437,6.349-6.349-1.288-1.288Zm7.8-7.8-.289.289,1.287,1.288.29-.289a.428.428,0,0,0,0-.6l-.7-.7a.423.423,0,0,0-.29-.114A.423.423,0,0,0,1113.158-2437.33Zm-16.162-.608h2.513a1.262,1.262,0,0,0,1.258-1.258v-2.119Z",
    transform: "translate(-1094 2444)",
    fill: "#ffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateBuilder);
export default __webpack_public_path__ + "static/media/TemplateBuilder.387b5ecc5eef8603c8f414dc27317170.svg";
export { ForwardRef as ReactComponent };